module.exports = __webpack_public_path__ + "static/img/MP@2x.93918f2e.jpg";